<sw-modal
    :title="$t('sw-extension-store.detail.inAppPurchases.label')"
    :subtitle="extension.name"
    variant="default"
    class="sw-extension-store-detail-in-app-purchases-listing-modal"
    @modal-close="closeInAppPurchasesListingModal"
>
    {% block sw_extension_store_detail_in_app_purchases_listing_modal_content %}
        <mt-loader
            v-if="inAppPurchases.length === 0"
        />
        <sw-collapse
            v-for="inAppPurchase in inAppPurchases"
            v-else
            :key="inAppPurchase.identifier"
            class="sw-extension-store-detail-in-app-purchases-listing-modal-content__collapse"
        >
            <template #header="{ expanded }">
                <div class="sw-extension-store-detail-in-app-purchases-listing-modal-content__title">
                    {{ inAppPurchase.name }}
                    {% block sw_extension_store_detail_in_app_purchases_listing_modal_header_icon %}
                        {% block sw_extension_store_detail_in_app_purchases_listing_modal_header_icon_expanded %}
                            <mt-icon
                                v-if="expanded"
                                class="sw-extension-store-detail-in-app-purchases-listing-modal-content__button"
                                name="regular-chevron-down-xs"
                                size="12px"
                            />
                        {% endblock %}

                        {% block sw_extension_store_detail_in_app_purchases_listing_modal_header_icon_not_expanded %}
                            <mt-icon
                                v-else
                                class="sw-extension-store-detail-in-app-purchases-listing-modal-content__button"
                                name="regular-chevron-right-xs"
                                size="12px"
                            />
                        {% endblock %}
                    {% endblock %}
                </div>
            </template>
            <template #content>
                <span class="sw-extension-store-detail-in-app-purchases-listing-modal-content__description">
                    {{ inAppPurchase.description }}
                </span>

                <span class="sw-extension-store-detail-in-app-purchases-listing-modal-content__description">
                    {{ $t('sw-extension-store.detail.inAppPurchases.paymentOptions') }}
                </span>

                <ul class="sw-extension-store-detail-in-app-purchases-listing-modal-content__payment-options">
                    <li v-for="(priceModel, index) in inAppPurchase.priceModels" :key="index">
                        {{ formatCurrency(priceModel.price, priceModel.currency) }}* {{ priceModel.type === 'rent' ? priceModel.variant : $t('sw-extension-store.in-app-purchases.onceOff') }}
                    </li>
                </ul>
            </template>
        </sw-collapse>
    {% endblock %}
    <span
        v-if="inAppPurchases.length"
        class="sw-extension-store-detail-in-app-purchases-listing-modal-content__tax-notice"
    >
        {{ $t('sw-extension-store.general.taxNotice') }}
    </span>

    <template #modal-footer>
        <mt-button
            variant="secondary"
            size="small"
            @click="closeInAppPurchasesListingModal"
        >
            {{ $t('global.default.close') }}
        </mt-button>
    </template>
</sw-modal>
